var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tips"},[_vm._v("\n    您访问的页面不存在,请修改后重试，或\n    "),_c('router-link',{attrs:{"replace":"","to":"/"}},[_vm._v("前往首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }